 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLCONTRIBUTORS from '@/components/xhtml/contributors'
 import XHTMLHALFTITLEA from '@/components/xhtml/halftitlea'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLFOREWORD from '@/components/xhtml/foreword'
 import XHTMLHALFTITLE1 from '@/components/xhtml/halftitle1'
 import XHTMLCH00 from '@/components/xhtml/ch00'
 import XHTMLPART01 from '@/components/xhtml/part01'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLPART02 from '@/components/xhtml/part02'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLCH15 from '@/components/xhtml/ch15'
 import XHTMLCH16 from '@/components/xhtml/ch16'
 import XHTMLCH17 from '@/components/xhtml/ch17'
 import XHTMLCH18 from '@/components/xhtml/ch18'
 import XHTMLPART03 from '@/components/xhtml/part03'
 import XHTMLCH19 from '@/components/xhtml/ch19'
 import XHTMLCH20 from '@/components/xhtml/ch20'
 import XHTMLCH21 from '@/components/xhtml/ch21'
 import XHTMLCH22 from '@/components/xhtml/ch22'
 import XHTMLCH23 from '@/components/xhtml/ch23'
 import XHTMLCH24 from '@/components/xhtml/ch24'
 import XHTMLCH25 from '@/components/xhtml/ch25'
 import XHTMLPART04 from '@/components/xhtml/part04'
 import XHTMLCH26 from '@/components/xhtml/ch26'
 import XHTMLCH27 from '@/components/xhtml/ch27'
 import XHTMLCH28 from '@/components/xhtml/ch28'
 import XHTMLCH29 from '@/components/xhtml/ch29'
 import XHTMLCH30 from '@/components/xhtml/ch30'
 import XHTMLCH31 from '@/components/xhtml/ch31'
 import XHTMLCH32 from '@/components/xhtml/ch32'
 import XHTMLPART05 from '@/components/xhtml/part05'
 import XHTMLCH33 from '@/components/xhtml/ch33'
 import XHTMLCH34 from '@/components/xhtml/ch34'
 import XHTMLCH35 from '@/components/xhtml/ch35'
 import XHTMLCH36 from '@/components/xhtml/ch36'
 import XHTMLCH37 from '@/components/xhtml/ch37'
 import XHTMLCH38 from '@/components/xhtml/ch38'
 import XHTMLPART06 from '@/components/xhtml/part06'
 import XHTMLCH39 from '@/components/xhtml/ch39'
 import XHTMLCH40 from '@/components/xhtml/ch40'
 import XHTMLCH41 from '@/components/xhtml/ch41'
 import XHTMLCH42 from '@/components/xhtml/ch42'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLAPP01 from '@/components/xhtml/app01'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLEDITORS from '@/components/xhtml/editors'
 import XHTMLSERVICES from '@/components/xhtml/services'
 import XHTMLJOIN from '@/components/xhtml/join'
 import XHTMLBM1 from '@/components/xhtml/bm1'
 import XHTMLBM2 from '@/components/xhtml/bm2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/foreword",
 			"name" : "xhtml/foreword",
 			"component" : XHTMLFOREWORD
 		},
 		{
 			"path" : "/xhtml/halftitle1",
 			"name" : "xhtml/halftitle1",
 			"component" : XHTMLHALFTITLE1
 		},
 		{
 			"path" : "/xhtml/ch00",
 			"name" : "xhtml/ch00",
 			"component" : XHTMLCH00
 		},
 		{
 			"path" : "/xhtml/part01",
 			"name" : "xhtml/part01",
 			"component" : XHTMLPART01
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
 		{
 			"path" : "/xhtml/ch03",
 			"name" : "xhtml/ch03",
 			"component" : XHTMLCH03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js